import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ProjectSale } from './project-sale';

@JsonObject('model.project.ProjectSale')
export class ProjectSales extends AbstractModel {

	@JsonProperty([ProjectSale], 'estimates')
	estimates?: ProjectSale[];

	@JsonProperty([ProjectSale], 'invoices')
	invoices?: ProjectSale[];

	@JsonProperty([ProjectSale], 'payments')
	payments?: ProjectSale[];
}
